import { render, staticRenderFns } from "./form_proveedor.vue?vue&type=template&id=9affc3f4&scoped=true"
import script from "./form_proveedor.vue?vue&type=script&lang=js"
export * from "./form_proveedor.vue?vue&type=script&lang=js"
import style0 from "./form_proveedor.vue?vue&type=style&index=0&id=9affc3f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9affc3f4",
  null
  
)

export default component.exports